import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { ResponsiveImageBlock } from '../types';
import { RichSegments } from './RichSegments';
import styles from './Image.module.css';
interface ResponsiveImageProps {
  block: ResponsiveImageBlock;
  blockId: string;
}
export function ResponsiveImage(t0) {
  const $ = _c(22);
  const {
    block,
    blockId
  } = t0;
  const {
    sources,
    fallback,
    caption,
    href,
    target,
    rel
  } = block;
  let t1;
  if ($[0] !== sources) {
    t1 = sources.map(_temp);
    $[0] = sources;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = fallback.sourceSrc ?? fallback.src;
  let t3;
  if ($[2] !== fallback.alt || $[3] !== fallback.height || $[4] !== fallback.src || $[5] !== fallback.width || $[6] !== t2) {
    t3 = <img src={fallback.src} alt={fallback.alt} width={fallback.width} height={fallback.height} className={styles.image} loading="lazy" data-src={t2} />;
    $[2] = fallback.alt;
    $[3] = fallback.height;
    $[4] = fallback.src;
    $[5] = fallback.width;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <picture className={styles.staticWrapper}>{t1}{t3}</picture>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== caption) {
    t5 = caption && caption.length > 0 ? <figcaption className={styles.caption}><RichSegments segments={caption} /></figcaption> : null;
    $[11] = caption;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== blockId || $[14] !== t4 || $[15] !== t5) {
    t6 = <figure className={styles.figure} data-cms-block-id={blockId} data-cms-field="responsiveImage">{t4}{t5}</figure>;
    $[13] = blockId;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const figure = t6;
  if (href) {
    let t7;
    if ($[17] !== figure || $[18] !== href || $[19] !== rel || $[20] !== target) {
      t7 = <a href={href} target={target} rel={rel} className={styles.link}>{figure}</a>;
      $[17] = figure;
      $[18] = href;
      $[19] = rel;
      $[20] = target;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    return t7;
  }
  return figure;
}
function _temp(source, idx) {
  return <source key={idx} media={source.media} srcSet={source.srcset} type={source.type} />;
}